import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';

const InnerWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexGrow: 999,
  alignItems: 'center',
  gap: theme.eclipseTier1.spacing['16px'],
}));

const components = { InnerWrapper };

export const S = {
  ...components,
  ...createClassNames('AlertBody', components),
} as const;
